import { useCatalogContext } from '@apps/registry/common/components/Catalog';
import { useAuth } from '@shared/components/AuthProvider';
import { MarcomAppNavBar, SeoHeaderLinks, useAppNavBar } from '@shared/components/Marcom/AppNavBar';
import { MarcomAppTelemetryProvider } from '@shared/components/Marcom/MarcomApp.telemetry';
import { useIsMobileOrTablet } from '@shared/utils/media/useMediaScreens';
import React, { useCallback, useMemo } from 'react';

interface TopNavProps
  extends Readonly<{
    showEventPickerDialog: () => void;
  }> {}

const useTopNav = (args: TopNavProps) => {
  const { showEventPickerDialog } = args;
  const { currentUser } = useAuth();
  const { eventId, hideMobileSideBarNav, eventHandle } = useCatalogContext();
  const isMobileOrTablet = useIsMobileOrTablet();
  const marcomTelemetryContext = useMemo(() => ({ eventId }), [eventId]);

  const { isMobileNavOpen, setMobileNavIsOpen } = useAppNavBar({ isMobile: isMobileOrTablet });

  const handleOnShowEventPicker = useCallback(() => {
    hideMobileSideBarNav();
    setMobileNavIsOpen(false);
    showEventPickerDialog();
  }, [hideMobileSideBarNav, showEventPickerDialog, setMobileNavIsOpen]);

  return { currentUser, eventId, eventHandle, handleOnShowEventPicker, isMobileNavOpen, isMobileOrTablet, marcomTelemetryContext, setMobileNavIsOpen };
};

export const TopNav: React.FC<TopNavProps> = props => {
  const { currentUser, eventId, eventHandle, handleOnShowEventPicker, isMobileNavOpen, marcomTelemetryContext, setMobileNavIsOpen } = useTopNav(props);

  return (
    <MarcomAppTelemetryProvider context={marcomTelemetryContext}>
      <SeoHeaderLinks />
      <MarcomAppNavBar
        currentUser={currentUser}
        eventId={eventId}
        eventHandle={eventHandle}
        onSwitchEventClick={handleOnShowEventPicker}
        isMobileNavOpen={isMobileNavOpen}
        setMobileNavIsOpen={setMobileNavIsOpen}
      />
    </MarcomAppTelemetryProvider>
  );
};
